module.exports = __webpack_public_path__ + "static/img/236_TO8_1991_og.f893e04.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/236_TO8_1991_og.jpg
// module id = YXi6
// module chunks = 0